import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/_layout/appointee/_layout/')({
  component: () => null, // La pagina la rende il layout.
});
